import { cx } from "./sortBlogs";
import { Link } from "react-router-dom";

const Category = ({ link = "#", name, active, ...props }) => {
  return (
    <Link
      to={link}
      className={cx(
        "border-dark dark:border-light ease m-2 inline-block rounded-full border-2 border-solid px-6 py-1.5 transition-all duration-200 hover:scale-105 md:px-10 md:py-2",
        props.className,
        active
          ? "bg-dark text-light dark:bg-light dark:text-dark"
          : "bg-light text-dark dark:bg-dark dark:text-light",
      )}
    >
      #{name}
    </Link>
  );
};

export default Category;
